import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AsociadosService, AutentificacionService, Usuario } from '../../api';
import { EncoderService } from './encoder.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private router: Router,
    private loginService: AutentificacionService,
    private encoderService: EncoderService,
    private asociadosService: AsociadosService
  ) { }

  checkToken(): boolean {
    return !this.checkExpireDateToken(this.encoderService.decrypt(localStorage.getItem('token')!))
  }

  //eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Ijg5NzYiLCJjYXJnbyI6WzFdLCJpYXQiOjE3MTMzMDQ4MDAwMDB9.E-_fVuq2Wg_Te5R6W5R07QVYkk0XAcV5mljTFBnFjsE
  checkExpireDateToken(token: string) {
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    return (Math.floor((new Date).getTime() / 1000)) >= expiry;
  }

  saveToken(token: string): void {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('token', this.encoderService.encrypt(token));
    }
  }

  async login(user: string, password: string) {
    let usuario: Usuario = {
      user,
      password: this.encoderService.encrypt(password)
    }
    return new Promise(async (resolve, reject) => {
      this.loginService.login(usuario).subscribe({
        next: (res: any) => {
          if (res.solicitud) {
            this.asociadosService.configuration.accessToken = res.solicitud.token!;
            // this.saveToken(res.solicitud.token!);
            resolve({code: 201, id: res.solicitud.id});
          } else {
            this.saveToken(res.token!);
            resolve({code: 200})
          }
        },
        error: error => {
          // 403: cuenta dada de baja (mensaje redactado por el servidor).
          // 409 LOGIN_IDENTIFICADOR_PERSONAL_REQUERIDO: el correo lo comparten varias personas; el servidor pide el documento personal.
          // Cualquier otro fallo: credenciales.
          if (error?.status === 429 || error?.status === 503) {
            resolve({code: error.status, message: 'Acceso temporalmente no disponible. Espera unos minutos o contacta con administración.'});
          } else if (error?.status === 403) {
            resolve({code: 403, message: error?.error?.status?.message});
          } else if (error?.status === 409 && error?.error?.status?.errorCode === 'LOGIN_IDENTIFICADOR_PERSONAL_REQUERIDO') {
            resolve({code: 409, message: error?.error?.status?.message});
          } else {
            resolve({code: 400});
          }
        }
      });
    });

  }

  public getToken() {
    let token = '';
    if (typeof localStorage !== 'undefined' && localStorage.getItem('token')) {
      token = this.encoderService.decrypt(localStorage.getItem('token')!);
    }
    return token;
  }

  logout() {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('token');
    }
    this.router.navigateByUrl('login');
  }

  get isLoggedIn(): boolean {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token')! : null;
    return token !== null ? this.checkToken() : false;
  }

  updatePassword(asociado: number, password: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.asociadosService.asociadosGetById(asociado).subscribe({
        next: (res: any) => {
          let usuario = res.asociados[0];
          usuario.password = this.encoderService.encrypt(password);
          this.asociadosService.asociadosPut(usuario, usuario.id).subscribe({
            next: (res: any) => {
              resolve(res); // Resuelve la promesa con la respuesta de la actualización
            },
            error: (error: any) => {
              reject(error); // Rechaza la promesa si hay un error en la actualización
            }
          });
        },
        error: (error: any) => {
          reject(error); // Rechaza la promesa si hay un error al obtener el usuario
        }
      });
    });
  }

}
